import { setCookie } from '../../utils/setCookie';
import { useAccountPicker } from '../account-picker/useAccountPicker';
var COPY_BOARD_INFO_ENUM = {
  COPY_BOARD_ACCOUNT_ID: 'copyBoardAccountId',
  COPY_TEMPLATE_META_ID: 'copyTemplateMetaId'
};

function saveInfoAndOpenApplication(metadataId, accountId, workspaceKey) {
  if (!metadataId) {
    return;
  }

  setCookie(COPY_BOARD_INFO_ENUM.COPY_TEMPLATE_META_ID, metadataId, 30);

  if (accountId) {
    setCookie(COPY_BOARD_INFO_ENUM.COPY_BOARD_ACCOUNT_ID, accountId, 30);
  }

  window.location.href = "".concat(workspaceKey ? "/s/".concat(workspaceKey) : '', "/app/");
}

function useTemplate(metadataId, setMetadataId) {
  var callback = function callback(accountId, workspaceKey) {
    return saveInfoAndOpenApplication(metadataId, accountId, workspaceKey);
  };

  return useAccountPicker({
    onAccountCancel: function onAccountCancel() {
      return setMetadataId(null);
    },
    onAccountError: function onAccountError() {
      return saveInfoAndOpenApplication(metadataId);
    },
    onAccountLoaded: callback,
    onAccountSubmited: callback
  });
}

export default useTemplate;